import { Callout } from './components/callout.tsx'
import { Xcelera } from './components/xcelera.tsx'

export const meta = () => [
	{ title: 'AI Diagnosis · xcelera docs' },
	{
		name: 'description',
		content:
			'AI diagnosis for Lighthouse audits: the root cause of a slow page, evidence cited from your measurements, and remediation steps for your stack.',
	},
]

# AI Diagnosis

A Chrome Lighthouse audit tells you everything that's wrong with a page, but not what matters most. It presents you with estimated savings that are overly optimistic, and it doesn't help you prioritize a fix.

Our AI diagnosis feature is the judgement that Lighthouse reports are missing: it suggests that one change that will actually move the needle, the evidence from your audit that backs it, and the fix that works for your stack.

## Running a diagnosis

Your organization's first successful audit is diagnosed automatically.

For any other successful audit, open its detail page from the dashboard and click **Diagnose**.

## What it looks at

The diagnosis reads the audit like a seasoned performance engineer:

- The network waterfall as a sequence: what blocked first paint, what was discovered late, and whether a critical request was actually starved by the other bytes in flight alongside it.
- Server response times across the audit's own runs and across your audit history. A server that answers in 260ms most of the time and 2 seconds when it starts cold has a different root cause than one that is slow on every load.
- Which element actually won Largest Contentful Paint, and whether that is even settled. A page whose hero image and heading trade places between loads has an LCP race, and fixing the image alone won't end it.
- Your audit history, so one bad load doesn't get diagnosed as a chronic problem.

## Next steps

- [Getting Started](/docs/getting-started) — add a page and run your first audit
- [Audit Stability](/docs/audit-stability) — how <Xcelera /> produces the stable measurements a diagnosis relies on
- [Performance Monitoring](/docs/performance-monitoring) — reading trends once the root cause is fixed
